// 9fbef606107a605d69c0edbcd8029e5d
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import React from 'react';
import PropTypes from 'prop-types';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { slpSubLabels, SLP_SUB_LABELS } from '@tcp/core/src/utils/labels/browse/SLP.labels';
import PreviousSearchTileView from '@tcp/core/src/components/common/molecules/PreviousSearchTile/views/PreviousSearchTile.view';
import style from '../styles/PreviousSearches.style';
import { capitalizeFirstWordOfSentence } from '../../../../../utils/utils.web';

const PreviousSearches = (props) => {
  const slpLabels = getLabelFromCopyOrFromTranslation(SLP_SUB_LABELS, slpSubLabels);

  let previousSearchesLabelText = renderLabel(
    slpLabels?.lbl_previous_searches,
    'lbl_previous_searches'
  );
  const { className, previousSearchList, closeSearchBar, onCloseClick, redesign } = props;
  if (redesign) {
    previousSearchesLabelText = capitalizeFirstWordOfSentence(previousSearchesLabelText);
  }
  return (
    <div className={`${className} previous-searches-desktop`}>
      <div className={`previous-searches-header ${redesign && 'redesign'}`}>
        {previousSearchesLabelText}
      </div>
      <div className="previous-searches-grid">
        {previousSearchList.map((productInfo) => {
          return (
            <div
              key={`${productInfo?.searchName}`}
              className={`product-tile-wrapper ${redesign && 'redesign'}`}
            >
              <PreviousSearchTileView
                {...productInfo}
                closeSearchBar={closeSearchBar}
                onCloseClick={onCloseClick}
                searchEnhancementRedesign
                redesign={redesign}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

PreviousSearches.propTypes = {
  className: PropTypes.string.isRequired,
  previousSearchList: PropTypes.arrayOf({
    id: PropTypes.string,
    imageUrl: PropTypes.string,
    searchName: PropTypes.string,
    size: PropTypes.string,
    color: PropTypes.string,
    gender: PropTypes.string,
  }),
};
PreviousSearches.defaultProps = {
  previousSearchList: [],
};
export { PreviousSearches as PreviousSearchesVanilla };
export default withStyles(PreviousSearches, style);
